import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { awardProjects } from '../data/awards';
import { routes } from '../data/site';
type AwardProject = (typeof awardProjects)[number];
export function ProjectsSection() {
  const [featured, ...supporting] = awardProjects;
  return <section id="projects" aria-labelledby="projects-title" className="section-y bg-olive text-ivory" data-id="element-188" data-mp="1kco7nrvytlbw">
      <div className="site-container" data-id="element-189" data-mp="mpp9tdtje7cf">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end lg:gap-10" data-id="element-190" data-mp="mqqnlq1xt7xu">
          <div className="lg:col-span-7" data-id="element-191" data-mp="rpbo7ql3ptmt">
            <p className="eyebrow text-ivory/70" data-id="element-192" data-mp="rqd1m1plas7p">Recognized craftsmanship</p>
            <h2 id="projects-title" className="section-title mt-4" data-id="element-193" data-mp="wlsccksaw7zw">
              See what experience can create.
            </h2>
            <p className="mt-4 max-w-[520px] text-[16px] leading-relaxed text-ivory/80" data-id="element-194" data-mp="11k3myxqf6mj6">
              Explore residential landscapes recognized for their design and construction.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6 lg:col-span-5 lg:justify-self-end" data-id="element-195" data-mp="39z2d03h5qiz1">
            <a href={routes.awards} className="focus-ring inline-flex min-h-[48px] items-center justify-center gap-3 bg-ivory px-6 text-[14.5px] font-medium text-olive transition-colors duration-150 hover:bg-stone" data-id="element-196" data-mp="34zftxdene8ib">
              View award-winning projects
              <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-197" data-mp="2r0g80diis7pu" />
            </a>
            <a href={routes.gallery} className="focus-ring inline-flex min-h-[44px] items-center text-[14.5px] text-ivory" data-id="element-198" data-mp="2m97w9atpwa9i">
              <span className="border-b border-ivory/40 pb-0.5 transition-colors duration-150 hover:border-ivory" data-id="element-199" data-mp="2d8rxufrtztbi">
                Explore the gallery
              </span>
            </a>
          </div>
        </div>

        <div className="mt-10 grid gap-10 lg:mt-12 lg:grid-cols-12 lg:gap-8" data-id="element-200" data-mp="23avkdhbf8ma8">
          <div className="lg:col-span-8" data-id="element-201" data-mp="23cyeacfp2zk8">
            <ProjectFigure project={featured} imageClass="aspect-[4/3] lg:aspect-auto lg:h-[600px]" large data-id="element-202" data-mp="1tlygokkxqfdb" />
          </div>
          <div className="flex flex-col gap-10 sm:grid sm:grid-cols-2 sm:gap-8 lg:col-span-4 lg:flex lg:flex-col" data-id="element-203" data-mp="1ynnta4nt313i">
            {supporting.map(project => <div key={project.id} className="flex flex-1 flex-col" data-id="element-204" data-mp="1ondieqp8u5ri">
                <ProjectFigure project={project} imageClass="aspect-[4/3] lg:aspect-auto lg:min-h-[220px] lg:flex-1" data-id="element-205" data-mp="2cdhjaqb1rret" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}
function ProjectFigure({
  project,
  imageClass,
  large = false
}: {
  project: AwardProject;
  imageClass: string;
  large?: boolean;
}) {
  return <figure className="flex h-full flex-1 flex-col" data-id="element-206" data-mp="27l6g9el0fpi1">
      <div className={`relative overflow-hidden bg-charcoal ${imageClass}`} data-id="element-207" data-mp="2vbtuehlirbd1">
        <img src={project.image} alt={project.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-208" data-mp="303229977aoo3" />
      </div>
      <figcaption className="mt-4 border-t border-ivory/15 pt-4" data-id="element-209" data-mp="jp9sij6z0yxo">
        <div className="flex items-baseline justify-between gap-4" data-id="element-210" data-mp="jmw0ykbi24uv">
          <span className={`font-display font-medium leading-tight ${large ? 'text-[28px]' : 'text-[24px]'}`} data-id="element-211" data-mp="ycl4gm72ekyb">
            {project.location}
          </span>
          <span className="text-[12px] font-medium uppercase tracking-[0.16em] text-ivory/65" data-id="element-212" data-mp="5oz21h9kpmd1">{project.year}</span>
        </div>
        {project.awards.map(award => <p key={award.title} className="mt-1.5 text-[14.5px] leading-relaxed text-ivory/80" data-id="element-213" data-mp="s8nwzhbx0u9">
            {award.title} · {award.category}
          </p>)}
      </figcaption>
    </figure>;
}